
import GwContentTemplate from '~/patterns/templates/content';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import getKnowledgePage from '~/graphql/queries/getKnowledgePage.graphql';
import seo from '~/mixins/seo';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import GwPageMeta from '~/patterns/molecules/page-meta/page-meta';
import GwQuestionAnswer from '~/patterns/molecules/question-answer/question-answer';
import GwAuthor from '~/patterns/organisms/author/author';
import GwError from '~/patterns/molecules/error';

export default {
    components: {
        GwContentTemplate,
        GwPageContainer,
        GwQuestionAnswer,
        GwPageMeta,
        GwAuthor,
        GwError,
        FlexibleSection,
    },
    mixins: [seo],
    data() {
        return {
            entry: null,
            notFound: false
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getKnowledgePage,
                { site, uri }
            );
        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }
    },
    methods: {
        formatDate(date) {
            return this.$d(new Date(date), 'dateShort');
        }
    },
    nuxtI18n: {
        paths: {
            en: '/knowledge/q-and-a/:slug',
            in: '/knowledge/q-and-a/:slug',
            nl: '/knowledge/q-and-a/:slug',
            fr: '/articles/q-and-a/:slug',
            de: '/knowledge/q-and-a/:slug',
            'en-Highberg': '/knowledge/q-and-a/:slug',
            'nl-Highberg': '/knowledge/q-and-a/:slug',
            'de-Highberg': '/knowledge/q-and-a/:slug',
        }
    }
};
